import { cssModule } from "../../shared";
export function useOverlayFocusRing({
  focus
} = {}) {
  return {
    className: cssModule("o-ui-overlay-focus-ring", focus && "focus")
  };
}